export const formatBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0) {
    return '0 Bajtů';
  }
  const base = 1024;
  const fixedDecimals = decimals < 0 ? 0 : decimals;
  const sizeUnits = ['Bajtů', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const unitIndex = Math.floor(Math.log(bytes) / Math.log(base));
  return `${Number.parseFloat((bytes / base ** unitIndex).toFixed(fixedDecimals))} ${sizeUnits[unitIndex]}`;
};
